import React from "react";

const CategoricalExpensesInRupee = ({ expenseData }) => {
  const isPositive = (changeRate) => {
    const value = parseFloat(changeRate);
    if (isNaN(value)) return null; // Handle invalid input
    return value > 0;
  };

  return (
    <div className="categoricalExpensesContainer poppins">
      <h3 className="underline-border mb-1 p-b-1 color-grayColor weight-500">
        Categorical expenses in rupees
      </h3>
      {expenseData.map((expense, index) => (
        <div
          key={index}
          style={{
            display: "grid",
            gridTemplateColumns: "2fr 4fr 1fr",
            alignItems: "center",
          }}
          className="underline-border expenseItem mt-2 mb-2"
        >
          <span className="expenseName color-deepGreen3">{expense.name}</span>
          <span className="expenseAmount t-32 color-gray">
            {expense.expenses.toLocaleString()}{" "}
            <span className="ml-1 color-textGray">₹</span>
          </span>
          <span
            className={`expenseChangeRate ${
              isPositive(expense.changeRate)
                ? "color-deepGreen3"
                : "color-redColor"
            }`}
          >
            {expense.changeRate} %
          </span>
        </div>
      ))}
    </div>
  );
};

export default CategoricalExpensesInRupee;
